import React, { useContext, useEffect, useState } from "react";
import "../assets/css/MisCursos.css";
import CCmenu from "../components/CCmenu";
import Contexto from "../context/Contexto";
import MiCurso from "../components/MiCurso";
import PresetComprado from "../components/PresetComprado";
import PH from "../assets/statics/programashibridos.png";
import { Link } from "react-router-dom";
const MisCursos = () => {
  const { cliente, cursoscomprados, CC, sorteados } = useContext(Contexto);
  const [tusCursos, setTusCursos] = useState([]);
  const [tusProgramas, setTusProgramas] = useState([]);

  const ConstruyeMisCursos = () => {
    let claves = Object.keys(cursoscomprados);
    let resultado = [];
    let programas = [];
    for (let i = 0; i < claves.length; i++) {
      if (cursoscomprados[claves[i]].info) {
        if (!cursoscomprados[claves[i]].info.esPrograma) {
          resultado.push(cursoscomprados[claves[i]]);
        } else {
          programas.push(cursoscomprados[claves[i]]);
        }
      }
    }
    resultado.sort((a, b) => {
      if (a.info.ordenFront > b.info.ordenFront) {
        return 1;
      }
      if (a.info.ordenFront < b.info.ordenFront) {
        return -1;
      }

      return 0;
    });
    setTusProgramas(programas);
    setTusCursos(resultado);
  };

  useEffect(() => {
    ConstruyeMisCursos();
    console.log("lo que me trae CC -->", CC);
  }, [cliente]);
  let guarda = () => {
    let pepe = { [cliente.uid]: cliente };
    sorteados(pepe);
  };
  return (
    <>
      {cliente && tusCursos && (
        <>
          <div className="contenedorMisCursos">
            {CC.estado ? (
              <>
                {/*
                <div className="vencidas">
                  <h3>
                    Ser barrabrava de este Club trae beneficios. <br />
                    Sumate al Design Season antes y con un precio especial.
                  </h3>
                  <br></br>
                  <p>
                    <Link
                      to="http://www.colorclub.online/secreto-ds"
                      className="formuBT verde"
                    >
                      solo por acá
                    </Link>
                     <br /> <br /> <br />
                    <div className="formuBT verde" onClick={guarda}>
                      TOCÁ ACÁ
                    </div> 
                  </p>
                </div>*/}

                <CCmenu />
              </>
            ) : (
              <>
                <div className="vencidas">
                  <h3>
                    Actualmente no tenés una suscripción activa en Color Club.
                  </h3>

                  <p>
                    {" "}
                    Suscribite <a href="https://www.colorclub.online/">ACÁ</a>
                  </p>
                </div>
              </>
            )}

            {tusCursos.length > 1 && (
              <h1 className="titular">TUS CURSOS COMPRADOS</h1>
            )}

            {tusCursos &&
              tusCursos.map((item, i) => {
                if (item.info.modal === "co") {
                  return (
                    <MiCurso
                      key={`${i}CO`}
                      {...item}
                      totales={cliente.progreso}
                      examen={cliente.examenes}
                    ></MiCurso>
                  );
                }
                if (item.info.modal === "co") {
                  return (
                    <MiCurso
                      key={`${i}CO2`}
                      {...item}
                      totales={cliente.progreso}
                      examen={cliente.examenes}
                    ></MiCurso>
                  );
                }
                if (item.info.modal === "prex") {
                  return (
                    <PresetComprado
                      key={item.info.nombre}
                      {...item.info}
                    ></PresetComprado>
                  );
                }
              })}
          </div>

          {tusProgramas.length > 0 && (
            <>
              <img src={PH} className="tituloH" />
              <div className="programas">
                {tusProgramas.map((item, i) => (
                  <MiCurso
                    key={`${i}programas`}
                    {...item}
                    totales={cliente.progreso}
                    examen={cliente.examenes}
                  ></MiCurso>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default MisCursos;
